<div class="main-section font-nunito relative min-h-screen bg-white text-sm font-normal antialiased dark:bg-[#060818]"
  [ngClass]="[store() && store()?.sidebar ? 'toggle-sidebar' : '', menuLayoutClass(), store() && store()?.layout, store() && store()?.rtlClass]">
  <!--  BEGIN MAIN CONTAINER  -->
  <div class="relative">
    <!-- sidebar menu overlay -->
      <div class="fixed inset-0 z-50 bg-[black]/60 lg:hidden" [ngClass]="{ hidden: !store() || !store()?.sidebar }"
      (click)="storeData.dispatch({ type: 'toggleSidebar' })"></div>

    @if(showTopButton()){
    <div  class="fixed bottom-14 z-50 ltr:right-2 rtl:left-6">
      <button type="button"
        class="btn btn-outline-primary animate-pulse rounded-full bg-[#fafafa] p-2 dark:bg-[#060818] dark:hover:bg-primary"
        (click)="goToTop()">
        <svg width="24" height="24" class="h-4 w-4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path opacity="0.5" fill-rule="evenodd" clip-rule="evenodd"
            d="M12 20.75C12.4142 20.75 12.75 20.4142 12.75 20L12.75 10.75L11.25 10.75L11.25 20C11.25 20.4142 11.5858 20.75 12 20.75Z"
            fill="currentColor" />
          <path
            d="M6.00002 10.75C5.69667 10.75 5.4232 10.5673 5.30711 10.287C5.19103 10.0068 5.25519 9.68417 5.46969 9.46967L11.4697 3.46967C11.6103 3.32902 11.8011 3.25 12 3.25C12.1989 3.25 12.3897 3.32902 12.5304 3.46967L18.5304 9.46967C18.7449 9.68417 18.809 10.0068 18.6929 10.287C18.5768 10.5673 18.3034 10.75 18 10.75L6.00002 10.75Z"
            fill="currentColor" />
        </svg>
      </button>
    </div>
    }

    <!-- BEGIN APP SETTING LAUNCHER -->
    <setting></setting>
    <!-- END APP SETTING LAUNCHER -->

    <div class="main-container min-h-screen text-black dark:text-white-dark" [ngClass]="[store() && store()?.navbar]">
      <!--  BEGIN SIDEBAR  -->

      <sidebar></sidebar>

      <!--  END SIDEBAR  -->
      <div class="main-content relative flex min-h-screen flex-col">
        <!--  BEGIN TOP NAVBAR  -->

        <header></header>

        <!--  END TOP NAVBAR  -->

        <!--  BEGIN CONTENT AREA  -->
        <div class="animation mx-auto w-full bg-white !pb-0 dark:bg-[#060818]"
          [ngClass]="[contentPaddingClass(), contentWidthClass(), contentMarginClass()]">
          <router-outlet></router-outlet>
        </div>
        <!--  END CONTENT AREA  -->

        <!-- BEGIN FOOTER -->
        <footer class="fixed bottom-0 left-0 right-0 z-10 !w-full"></footer>
        <!-- END FOOTER -->
      </div>
    </div>

    <!-- Session Warning Dialog -->
    <app-session-warning-dialog [show]="showWarning()" (continueSession)="continueSession()" (logout)="logout()">
    </app-session-warning-dialog>
  </div>
</div>